import { useUserEmailIfLoggedIn } from '@/auth/authentication';
import { APOLLO_CACHE_CONFIG, APOLLO_LINK } from '@/fetching/graphql/GraphQLClient';
import {
    ApolloClient,
    InMemoryCache,
    NormalizedCacheObject,
    ApolloProvider as Provider,
    useApolloClient,
} from '@apollo/client';
import { FC, ReactNode, useCallback, useMemo, useRef } from 'react';

export const useResetStore = () => {
    const client = useApolloClient();

    return useCallback(() => {
        client.stop();
        return client.resetStore();
    }, [client]);
};

const createClient = (_user: unknown) => {
    const cache = new InMemoryCache(APOLLO_CACHE_CONFIG);
    return new ApolloClient({
        cache,
        link: APOLLO_LINK,
    });
};

type ApolloProviderProps = {
    children: ReactNode;
};

export const ApolloProvider: FC<ApolloProviderProps> = (props) => {
    const { children } = props;
    const user = useUserEmailIfLoggedIn();
    const prevClientRef = useRef<ApolloClient<NormalizedCacheObject> | null>(null);

    const graphqlClient = useMemo(() => {
        if (prevClientRef.current) {
            prevClientRef.current.stop();
        }

        const newClient = createClient(user);
        prevClientRef.current = newClient;

        return newClient;
    }, [user]);

    return <Provider client={graphqlClient}>{children}</Provider>;
};
